<template>
  <div class="cvcql-date-time-inputs">
    <v-menu
      v-model="timeMenu"
      :close-on-content-click="false"
      transition="scale-transition"
      offset-y
    >
      <template v-slot:activator="{ on, attrs }">
        <div class="d-inline-flex">
          <v-icon
            class="mx-2"
            :style="iconHeight ? { 'font-size': iconHeight + 'px' } : {}"
          >
            mdi-clock
          </v-icon>
          <v-text-field
            readonly
            dense
            hide-details
            single-line
            :value="timeValue"
            prepend-icon=""
            v-bind="attrs"
            v-on="on"
            :height="height ? height + 'px' : null"
            :style="width ? { width: width + 'px' } : {}"
            :clearable="clearable"
          />
        </div>
      </template>
      <v-time-picker
        v-model="timeValue"
        :min="minTime"
        :max="maxTime"
      />
    </v-menu>
  </div>
</template>

<script>
export default {
  name: "CvcTimeInput",
  data: () => ({
    timeValue: null,
    timeMenu: false,
    iconHeight: 20,
    height: 14,
    width: 100,
  }),
  props: {
    value: {
      type: String,
      required: true,
    },
    clearable: {
      type: Boolean,
    },
    minTime: {
      type: String,
    },
    maxTime: {
      type: String,
    },
  },
  watch: {
    timeValue(newVal) {
      this.$emit("input", newVal);
    },
    value: {
      handler(newVal) {
        this.timeValue = newVal;
      },
      immediate: true,
    },
  },
};
</script>
